import React, { useEffect } from "react";
import { LoadingIndicator } from "@leagueplatform/web-common-components";
import { useAuth } from "@leagueplatform/auth-utils";
import { useNavigate, useLocation, Outlet } from "react-router-dom";

export const AuthSessionContainer = () => {
  const { isAuthenticated, error } = useAuth({
    redirectToLogInWhenSignedOut: true,
  });

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (error) {
      // Redirect to landing page if other auth errors occur
      const urlErrorParams = new URLSearchParams();
      urlErrorParams.append("error", error.type);
      if (error.description) {
        urlErrorParams.append("error_description", error.description);
      }

      navigate(`/?${urlErrorParams}`, { replace: true });
    }
  }, [error, navigate, location]);

  if (!isAuthenticated) return <LoadingIndicator />;

  return <Outlet />;
};
